import { render } from "./ImportacaoPedidoAgesul.vue?vue&type=template&id=500f0a05"
import script from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
export * from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
script.render = render

export default script